import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import QRCode from "react-qr-code";
import { useTheme } from "styled-components";

import messages from "./messages";
import { Container, Popup, Text, Wrapper } from "./styles";

const getSize = () => {
    return Math.min(window.innerHeight, window.innerWidth) - 32 * 2;
}
const QrCodeToDownloadApp = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { c } = useTheme();
    const onToggle = () => setIsOpen(old => !old);
    return (
        <Container>
            <Text className="link" onClick={onToggle}>
                <FormattedMessage {...messages.text}/>
            </Text>
            {isOpen && (
                <Popup onClick={onToggle}>
                    <Wrapper>
                        <QRCode value="https://musicators.com/app" size={getSize()} bgColor={c.snowOnActive}/>
                    </Wrapper>
                </Popup>
            )}
        </Container>
    );
};

export default QrCodeToDownloadApp;
